import { HeartHandshake, ShieldCheck, Monitor, UserCheck, Check, ArrowRight } from 'lucide-react';
import { services } from '../data';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const iconMap = {
  HeartHandshake: HeartHandshake,
  ShieldCheck: ShieldCheck,
  Monitor: Monitor,
  UserCheck: UserCheck,
};

export default function ServicesSection() {
  return (
    <section id="services" className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-[#103B66] mb-4">
            Sådan hjælper vi
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Vi tilbyder hjælp til alt det digitale, så du kan føle dig tryg igen.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-8">
          {services.map((service, index) => {
            const Icon = iconMap[service.icon];
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="flex flex-col h-full"
              >
                <div className="group p-8 flex-grow shadow-xl flex flex-col bg-white text-slate-800 hover:bg-[#103B66] hover:text-white transition-all duration-300 border border-slate-100 rounded-none">
                  <div className="text-slate-900 group-hover:text-white transition-colors duration-300 mb-6">
                    <Icon className="w-12 h-12" />
                  </div>
                  <h3 className="text-xl font-bold mb-6 text-[#103B66] group-hover:text-white transition-colors duration-300">
                    {service.category}
                  </h3>
                  <ul className="space-y-4 mb-8 flex-grow">
                    {service.items.map((item, i) => (
                      <li key={i} className="flex items-start text-slate-600 group-hover:text-slate-200 transition-colors duration-300">
                        <Check className="w-6 h-6 mr-3 shrink-0 mt-0.5 text-slate-900 group-hover:text-white transition-colors duration-300" />
                        <span className="flex items-baseline gap-2">
                          <span>{item.name}</span>
                        </span>
                      </li>
                    ))}
                  </ul>
                  <Link 
                    to={service.href}
                    className="inline-flex items-center font-bold text-[#103B66] group-hover:text-white hover:underline transition-all duration-300"
                  >
                    Læs mere om {service.category.toLowerCase()}
                    <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
                  </Link>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
